import { BookkeepingItem } from '../types/bookkeepingItem'

export const isCrossCurrencyMatch = (selectedItems: BookkeepingItem[], accountCurrency?: string): boolean => {
  if (!accountCurrency) {
    return false
  }

  return selectedItems.some((item) => item.currency && item.currency !== accountCurrency)
}
